module.exports = __webpack_public_path__ + "static/media/icon_police.75be7a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_police.png
// module id = 524
// module chunks = 0